import React from 'react';
import './styles.scss';
export const CustomDropDown = ({
  disabled,
  placeholder,
  className = '',
  value,
  onChange,
  options = [],
}) => {
  const generateOptions = () => {
    const emptyOption = <option disabled selected={!value} value> SELECCIONAR... </option>;
    const optReal = options.map((option) => (
      <option
        key={option?.key}
        value={option?.key}
        className={'custom-drop-down-option'}
        selected={option?.key === value}
      >
        {option?.text}
      </option>
    ));
    return [emptyOption, optReal];
  };

  return (
    <div>
      <div className={`${disabled && 'disabled-selector-container'}`}>
        <select
          value={value}
          className={`custom-drop-dowm ${className}`}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => {
            return onChange(e, {
              'value': e?.target?.value,
              'name': e?.target?.name,
            });
          }
          }
        >
          {generateOptions()}
        </select>
      </div>
    </div>
  );
};
